import type {PropsWithChildren} from 'react';
import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import styles from './list.module.css';

type Props = PropsWithChildren;

export function BreadCrumbList({children}: Props) {
  return (
    <ol
      className={clsx(
        styles.list,
        isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
      )}
    >
      {children}
    </ol>
  );
}
